import React, { Component } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { s360ConfigService } from "../../Services/S360Config";
import DayjsUtils from '@date-io/dayjs';
import dayjs from "dayjs";
import { dateByAdding, isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
class MessageA5 extends Component {

  constructor(props) {
    super(props);
    let dateInputs = this.parseDateInputs(props);
    this.state = { dateInputs: dateInputs, selectedDate: dateInputs.maxDate || new Date(),value:"",actionDone:false }
  }

  render() {
    let displayText = this.props.entry.text;
   
    return (
      <div className="s360-message-cotainer-received">
        <div className="s360-message-box-custom-a14-received" style={this.messageBoxStyle()}>
          {displayText && <div>{displayText}</div>}
          <div style={{padding: "10px"}}>
            <MuiPickersUtilsProvider locale="nl" utils={DayjsUtils}>
            <ThemeProvider theme={this.materialTheme}>
              <KeyboardDatePicker allowKeyboardControl={false}
                autoOk  {...this.state.dateInputs} variant="inline" label="" format="DD/MM/YY" value={this.state.selectedDate} helperText="" onChange={this.onDateSelect} />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </div>
        </div>
        {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
              <div className="s360-message-cotainer-received">
                    <button disabled={!this.state.value} className="s360-message-box-custom-a15-received" onClick={this.onSubmit} onMouseEnter={this.onMouseEnterButton} onMouseLeave={this.onMouseLeaveButton} style={this.messageBoxSubmitStyle()}>
                        {(this.props.entry.data)?JSON.parse(this.props.entry.data).buttonText:'Submit'}
                    </button>
              </div>
      </div>
      
    );
  }

  onMouseEnterButton = (e) => {
    if (!e.target) { return }
    if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonHighlightTextColor) ? "#f8f5f5" : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "#2935dd" : designDetails.buttonHighlightBackgroundColor;
  }

  onMouseLeaveButton = (e) => {
    if (!e.target) { return }
    // if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "#0092ed" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "#fff" : designDetails.buttonBackgroundColor;
  }

  parseDateInputs = (props) => {
    let dateInputs = {};
    if (props.entry.data) {
      let data = JSON.parse(props.entry.data)
      if (data.from_day) { dateInputs.minDate = dateByAdding(data.from_day); }
      if (data.to_day)   { dateInputs.maxDate = dateByAdding(data.to_day);  }
    }
    return dateInputs;
  }

  messageBoxStyle = () => {
    return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
  }

  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = { 
        // background: s360ConfigService.config.designDetails.recieverMessageColor, 
        fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
        fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
        // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        marginLeft: '15px',
        borderWidth:"1px", 
        borderStyle: "solid",
        borderColor: isNullOrUndefined(designDetials.buttonBorderColor) ? "#0092ed" : designDetials.buttonBorderColor,

        borderRadius:    isNullOrUndefined(designDetials.buttonBorderRadius)    ? 20 : designDetials.buttonBorderRadius,
        color:           isNullOrUndefined(designDetials.buttonTextColor)       ? "#0092ed" : designDetials.buttonTextColor,
        backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor) ? "#fff" : designDetials.buttonBackgroundColor,
    }
    return styleData;
    // return { 
    //   background: s360ConfigService.config.designDetails.recieverMessageColor,
    //    fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
    //    fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
    //    color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //    marginLeft: '15px' 
    //   }
}

  onDateSelect = (selectedDate) => {
   this.setState({ selectedDate: selectedDate,value: selectedDate});
    if(this.state.actionDone){
    this.setState({selectedDate: selectedDate,value: false});
    }
    else{
      this.setState({ selectedDate: selectedDate,value: selectedDate});
    }

   //this.props.actions.sendMessage(dayjs(selectedDate).format("DD/MM/YY"));
  }

  onSubmit = (e) => {
    this.onMouseLeaveButton(e);
    this.setState({value: false,actionDone:true});
    this.props.actions.sendMessage(dayjs(this.state.selectedDate).format("DD/MM/YY"));
 }

  materialTheme = createMuiTheme({

    palette: {
      primary: {
        main: '#3047ec',
        light: '#3047ec',
        dark: '#3047ec',
      },
      secondary: {
        main: '#3047ec',
      }
    },
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#3047ec',
          
        }
      },

      MuiPickersDay: {
        day: {
          color: '#3047ec',
        },
        daySelected: {
          backgroundColor:'#3047ec',
        },
        dayDisabled: {
          color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        },
        current: {
          color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        },
      },
      MuiPickersModal: {
        dialogAction: {
          color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        },
      },
    },
  });

}

export default MessageA5;